<template>
  <v-container class="text-right">
    <v-btn color="primary" text large @click="$emit('reset')" :disabled="loading" v-if="!hideReset">
      <v-icon left>remove</v-icon>reset
    </v-btn>
    <v-btn
      color="primary"
      text
      large
      :loading="loading"
      :disabled="disableSumbit"
      @click="$emit('submit')"
      type="submit"
    >
      <v-icon left>save</v-icon>
      {{submitText || 'save'}}
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "AFormActions",
  props: ["loading", "disableSumbit", "submitText", "hideReset"]
};
</script>